import {
  DateRangePicker,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@racoon/ui";
import { ORDER_DATE_PRESETS } from "../../model/use.order.filters";

type Props = {
  /** The days the map lists, from–to: the same range as the registry's. */
  from: Date;
  to: Date;
  onDateChange: (key: "startDate" | "endDate", value: Date) => void;
  /** Which of the job's time columns the range applies to. */
  dateField: string;
  dateFields: { id: string; name: string }[];
  onDateFieldChange: (field: string) => void;
};

/**
 * The order map's window: a range of days, stepped with ‹ › while it is a single day, and
 * the column it applies to. It is the URL's range, so the registry opens on it too.
 */
export const JobMapDateFilter = ({
  from,
  to,
  onDateChange,
  dateField,
  dateFields,
  onDateFieldChange,
}: Props) => (
  <>
    <DateRangePicker
      showDayNav
      presets={ORDER_DATE_PRESETS}
      align="start"
      initialDateFrom={from}
      initialDateTo={to}
      onUpdate={({ range }) => {
        if (!range.from) return;
        onDateChange("startDate", range.from);
        onDateChange("endDate", range.to ?? range.from);
      }}
    />
    <Select value={dateField} onValueChange={onDateFieldChange}>
      {/* 233px in the design */}
      <SelectTrigger className="h-8 !w-[233px] !rounded-lg bg-white text-text-body">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {dateFields.map((field) => (
          <SelectItem key={field.id} value={field.id}>
            {field.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </>
);
